import { FirebaseOptions } from 'firebase/app';

export const FIREBASE_EVENT_NAME = 'request_waiting_list';

const FIREBASE_CONFIG: FirebaseOptions = {
  apiKey: process.env.NEXT_PUBLIC_FIREBASE_API_KEY,
  authDomain: process.env.NEXT_PUBLIC_FIREBASE_AUTH_DOMAIN,
  projectId: process.env.NEXT_PUBLIC_FIREBASE_PROJECT_ID,
  storageBucket: process.env.NEXT_PUBLIC_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.NEXT_PUBLIC_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.NEXT_PUBLIC_FIREBASE_APP_ID,
  measurementId: process.env.NEXT_PUBLIC_FIREBASE_MEASUREMENT_ID,
};

export const FIREBASE_LOGGER_EVENT_NAME = 'event_log';

export const FIREBASE_LOGGER_CONFIG: FirebaseOptions = {
  apiKey: process.env.NEXT_PUBLIC_FIREBASE_LOGGER_API_KEY,
  authDomain: process.env.NEXT_PUBLIC_FIREBASE_LOGGER_AUTH_DOMAIN,
  projectId: process.env.NEXT_PUBLIC_FIREBASE_LOGGER_PROJECT_ID,
  storageBucket: process.env.NEXT_PUBLIC_FIREBASE_LOGGER_STORAGE_BUCKET,
  messagingSenderId:
    process.env.NEXT_PUBLIC_FIREBASE_LOGGER_MESSAGING_SENDER_ID,
  appId: process.env.NEXT_PUBLIC_FIREBASE_LOGGER_APP_ID,
  measurementId: process.env.NEXT_PUBLIC_FIREBASE_LOGGER_MEASUREMENT_ID,
};

export default FIREBASE_CONFIG;
